// extracted by mini-css-extract-plugin
export var quillEditor = "_k3-1";
export var variable = "_k3-0";